import styled from "styled-components"

export const InfoRowContainer = styled.div`
  margin: 60px 0;
`
export const Wrapper = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 15px;

  h3 {
    color: ${props => props.theme.colors.darkBlue};
    max-width: 500px;
    margin-bottom: 24px;
    transition: 0.3s ease;
    @media (max-width: 425px) {
      font-size: 26px;
    }
    @media (max-width: 375px) {
      font-size: 24px;
    }
  }
`
export const SliderContainer = styled.div`
  overflow: hidden;
  display: flex;
  width: 100%;

  .slick-slider {
    overflow: hidden;
    display: flex;
  }

  .left {
    flex: 1;
  }

  .right {
    flex: 1;
  }
`

export const Slide = styled.div`
  text-align: center;

  img {
    width: 150px;
    height: 150px;
    object-fit: contain;
    margin: 0 auto;
  }

  h5 {
    margin: 24px 0;
    color: ${props => props.theme.colors.darkBlue};
    text-transform: uppercase;
  }

  p {
    margin-bottom: 16px;
    max-width: 250px;
    margin: 0 auto 16px auto;
    color: ${props => props.theme.colors.darkBlue};
    strong {
      font-weight: 500;
    }
  }
`
export const SliderArrow = styled.div`
  flex: 1;
  height: 100%;
  display: flex;
  align-items: center;
  &:hover {
    cursor: pointer;
  }

  svg {
    color: ${props => props.theme.colors.darkBlue};
    font-size: 32px;
  }
`
